import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { canAccessPath, getDefaultDashboardRoute } from "../utils/permissions";

const DashboardRouteGuard = () => {
  const location = useLocation();

  if (!canAccessPath(location.pathname)) {
    return <Navigate to={getDefaultDashboardRoute()} replace />;
  }

  return <Outlet />;
};

export default DashboardRouteGuard;
